var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"position":"absolute","top":"120px","left":"200px"},attrs:{"src":_vm.url,"id":"mobsf","scrolling":"yes","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }